import React, { useContext, useEffect, useState } from 'react';
import axios from "axios";
import { Link, navigate } from "raviger";
import { Field, Form, Formik, } from 'formik';
import {
  Button,
  ButtonGroup,
  Card,
  Col,
  Form as BootstrapForm,
  ListGroup,
  Modal,
  OverlayTrigger,
  Row,
  Tooltip,
} from 'react-bootstrap';
import moment from 'moment';
import * as Yup from 'yup';
import {
  faArrowAltCircleLeft, faEdit, faEyeSlash, faTimes, faGlobe,
  faUserGear, faClone
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TextInput, DateTimePicker } from '../components/Form.js';
import ButtonSpinner from '../components/ButtonSpinner.js';
import { SystemErrorContext } from '../components/SystemError';
import { AuthContext } from "../accounts/AccountsReducer";
import Header from '../components/Header';
import LoadingLink from '../components/LoadingLink';
import ActionsDropdown from '../components/ActionsDropdown';
import { faCircleC, faCircleT, faClockRotateLeft, faClonePlus, faArrowRightToBracket } from '@fortawesome/pro-solid-svg-icons';

const IncidentManagement = ({ organization }) => {

  const { setShowSystemError } = useContext(SystemErrorContext);
  const { state } = useContext(AuthContext);
  const [incidentNames, setIncidentNames] = useState([]);

  const [incidentFilter, setIncidentFilter] = useState('');
  const [selectedIncident, setSelectedIncident] = useState(null);
  const [showRemovalModal, setShowRemovalModal] = useState(false);
  const handleRemovalClose = () => setShowRemovalModal(false);
  const handleRemovalShow = () => setShowRemovalModal(true);
  // Handle hiding an incident.
  const handleRemovalConfirm = () => {
    axios.patch(`/incident/api/incident/${selectedIncident}/hide/`, { hide: true })
      .then(() => {
        setData(data.filter(incident => incident.id !== selectedIncident));
        setFilteredData(filteredData.filter(incident => incident.id !== selectedIncident));
        setSelectedIncident(null);
        setShowRemovalModal(false);
      })
      .catch(error => {
        console.error("Error hiding incident:", error);
        setShowSystemError(true);
      });
  };

  const get_slug = (incident_name) => {
    const new_slug = incident_name
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')  // Replace any group of non-alphanumerics with a single dash
    .replace(/^-+|-+$/g, '');
    setNewSlug(new_slug);
    return new_slug;
  }

  const [showCloneModal, setShowCloneModal] = useState(false);
  const handleCloneClose = () => setShowCloneModal(false);
  const handleCloneShow = () => setShowCloneModal(true);

  const [newSlug, setNewSlug] = useState("");
  const [baseIncident, setBaseIncident] = useState([]);
  const [cloneAmount, setCloneAmount] = useState("");
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  // Handle opening and closing an incident.
  const handleOpenCloseSubmit = async (id) => {
    await axios.patch('/incident/api/incident/' + id + '/?organization=' + state.organization.id, {change_lock:true})
    .then(response => {
      setData(prevState =>
        prevState.map(item =>
          Number(item.id) === Number(id)
            ? { ...item, end_time: response.data.end_time }
            : item
        )
      );
      setFilteredData(prevState =>
        prevState.map(item =>
          Number(item.id) === Number(id)
            ? { ...item, end_time: response.data.end_time }
            : item
        )
      );
    })
    .catch(error => {
      setShowSystemError(true);
    });
  }

  useEffect(() => {
    if (incidentFilter) {
      setFilteredData(data.filter(incident => (String(incident.name).toLowerCase().includes(String(incidentFilter).toLowerCase()) || moment(incident.start_time).format('MM/DD/YYYY').includes(incidentFilter.toLowerCase().replace('-','/')) || (incident.end_time && moment(incident.end_time).format('MM/DD/YYYY').includes(incidentFilter.toLowerCase().replace('-','/'))))))
    }
    else {
      setFilteredData(data);
    }
  }, [incidentFilter]);

  useEffect(() => {
    let unmounted = false;
    let source = axios.CancelToken.source();
    if (state.user.is_superuser || state.user.incident_perms) {
      const fetchIncidentData = async () => {
        // Fetch Incident data.
        await axios.get('/incident/api/incident/?organization_slug=' + organization, {
          cancelToken: source.token,
        })
        .then(response => {
          if (!unmounted) {
            setData(response.data);
            setFilteredData(response.data);
            const incident_names = [];
            for (const incident of response.data) {
              incident_names.push(incident.slug);
            }
            setIncidentNames(incident_names);
          }
        })
        .catch(error => {
          if (!unmounted) {
            setShowSystemError(true);
          }
        });
      };
      fetchIncidentData();
    }
    // Cleanup.
    return () => {
      unmounted = true;
      source.cancel();
    };
  }, [organization]);

  return (
    <>
      {state.user.is_superuser || state.user.incident_perms ? <span className="mt-3 ms-auto me-auto" style={{width:"80%", maxWidth:"80%"}}>
      <Header>
        <span style={{cursor:'pointer'}} onClick={() => navigate("/" + organization)} className="me-2"><FontAwesomeIcon icon={faArrowAltCircleLeft} size="sm" inverse /></span>
        {state.organization.name} - Manage Incidents
      </Header>
      <Row className="ms-0" style={{marginRight:"9px"}}>
        <Col xs="3" className="ps-0 pe-0">
          <ButtonGroup className="w-100">
            <Button
              type="button"
              className="btn btn-primary"
              onClick={() => { navigate("/" + organization + "/incident/new") }}
            >
              Create New Incident
            </Button>
          </ButtonGroup>
        </Col>
        <Col xs="4" className="ps-0 pe-0">
          <BootstrapForm.Control type="text" placeholder="filter Incidents..." onChange={(e) => {
            setIncidentFilter(e.target.value);
          }} />
        </Col>
      </Row>
    {filteredData.map(incident => (
      <div key={incident.id} className="row mt-2">
        <div className="col-10 d-flex">
          <Card className="border rounded d-flex" style={{width:"100%"}}>
            <Card.Body style={{marginLeft:"5px"}}>
              <ListGroup variant="flush" style={{marginTop:"-13px", marginBottom:"-13px", marginLeft:"-20px"}}>
                <ListGroup.Item>
                  <Row style={{marginBottom:"-10px"}}>
                    <Col xs="10">
                      <span>
                        <b>Incident: </b>{incident.name}
                        {incident.training ? <OverlayTrigger
                          key={"incident-training"}
                          placement="top"
                          overlay={
                            <Tooltip id={`tooltip-incident-training`}>
                              This incident is flagged for training purposes.
                            </Tooltip>
                          }
                        >
                          <FontAwesomeIcon icon={faCircleT} className=" ms-1 me-1" />
                        </OverlayTrigger> : ""}
                        {incident.caltopo_map_id ? <OverlayTrigger
                          key={"incident-caltopo-map-id"}
                          placement="top"
                          overlay={
                            <Tooltip id={`tooltip-incident-training`}>
                              This incident has a CalTopo map ({incident.caltopo_map_id}) assigned.
                            </Tooltip>
                          }
                        >
                          <FontAwesomeIcon icon={faCircleC} className=" ms-1 me-1" />
                        </OverlayTrigger> : ""}
                        {incident.has_public_animals ? <OverlayTrigger
                          key={"incident-public"}
                          placement="top"
                          overlay={
                            <Tooltip id={`tooltip-incident-training`}>
                              This incident has public animals.
                            </Tooltip>
                          }
                        >
                          <FontAwesomeIcon icon={faGlobe} className=" ms-1 me-1" />
                        </OverlayTrigger> : ""}
                        &nbsp;({moment(incident.start_time).format('MM/DD/YYYY')}{incident.end_time ? <span> - {moment(incident.end_time).format('MM/DD/YYYY')}</span> : ""})
                        - Animal Count: {incident.animal_count} / SR Count: {incident.service_request_count} / FA Count: {incident.field_assignment_count}
                      </span>
                    </Col>
                    <Col className="pe-0" style={{marginRight:"-15px", marginTop:"-7px"}}>
                      <ActionsDropdown variant="secondary" title={"Actions"} className="float-end" style={{marginTop:"-1px", marginRight:"-2px"}}>
                        <LoadingLink
                          href={"/" + organization + "/" + incident.slug }
                          className="d-block"
                          isLoading={false}
                          label="Enter Incident"
                        >
                          <FontAwesomeIcon icon={faArrowRightToBracket} className="fas" inverse />
                        </LoadingLink>
                        <LoadingLink
                          href={"/" + organization + "/incident/edit/" + incident.id}
                          className="d-block"
                          isLoading={false}
                          label="Update Incident"
                          >
                          <FontAwesomeIcon icon={faEdit} className="fas" inverse />
                        </LoadingLink>
                        <LoadingLink
                          href={"/" + organization + "/incident/" + incident.id + "/manage/accounts"}
                          className="d-block"
                          isLoading={false}
                          label="Manage Incident Access"
                          disabled={!(state.user.is_superuser || (state.user.incident_perms && state.user.user_perms))}
                          disabled_text="You do not have the correct permission."
                          >
                          <FontAwesomeIcon icon={faUserGear} className="me-1" style={{marginLeft:"-3px"}} inverse />
                          
                        </LoadingLink>
                        <LoadingLink
                          className="d-block"
                          isLoading={false}
                          onClick={() => window.open(`/public/search?organization=${organization}&incident=${incident.slug}`, '_blank', 'noopener,noreferrer')}
                          label="View Public Incident Page"
                          disabled={!incident.has_public_animals}
                          disabled_text="Incident has no public animals."
                          >
                          <FontAwesomeIcon icon={faGlobe} className="fas" inverse />
                        </LoadingLink>
                        {state.organization.beta_features ?
                          <LoadingLink
                            isLoading={false}
                            className="d-block"
                            onClick={() => {
                              setSelectedIncident(incident.id);
                              setBaseIncident({
                                name: incident.name,
                                startTime: incident.start_time
                              });
                              handleCloneShow(true);
                            }}
                            label="Clone Incident"
                          >
                            <FontAwesomeIcon icon={faClonePlus} className="fas" size="lg" inverse />
                          </LoadingLink> :
                        ''}
                        <LoadingLink
                          isLoading={false}
                          className="d-block"
                          onClick={() => {handleOpenCloseSubmit(incident.id);}}
                          label={(incident.end_time ? "Show" : "Hide") + " Incident"}
                        >
                          {!incident.end_time ? <FontAwesomeIcon icon={faEyeSlash} className="fas" inverse /> : <FontAwesomeIcon icon={faClockRotateLeft} className="fas" style={{marginLeft:"-2px"}} inverse />}
                        </LoadingLink>
                        <LoadingLink
                          isLoading={false}
                          className="d-block"
                          onClick={() => {setSelectedIncident(incident.id);handleRemovalShow();}}
                          label="Remove Incident"
                        >
                          <FontAwesomeIcon icon={faTimes} className="fas" size="lg" inverse />
                        </LoadingLink>
                      </ActionsDropdown>
                    </Col>
                  </Row>
                </ListGroup.Item>
                {/* <ListGroup.Item>
                  <span>
                    <b>URL: </b>{window.location.protocol + '//' + window.location.host + "/" + organization + "/accounts/signup/" + incident.id.replaceAll('-','')}
                    <OverlayTrigger
                      key={"view-qrcode"}
                      placement="bottom"
                      overlay={
                        <Tooltip id={`tooltip-view-qrcode`}>
                          View QRcode
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon icon={faQrcode} className="ms-2" onClick={() => {setShowRemovalModal(window.location.protocol + '//' + window.location.host + "/" + organization + "/accounts/signup/" + current_data.id.replaceAll('-',''));}} style={{cursor:'pointer'}} inverse />
                    </OverlayTrigger>
                  </span>
                </ListGroup.Item> */}
              </ListGroup>
            </Card.Body>
          </Card>
        </div>
      </div>
    ))}
    <Modal show={showRemovalModal} onHide={handleRemovalClose}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Incident Removal</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        This action will remove the incident for all users and is only reversible by an administrator. Are you sure you want to proceed?
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleRemovalClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleRemovalConfirm}>
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>

    <Modal show={showCloneModal} onHide={handleCloneClose}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Incident Clone</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={{ 
            cloneAmount: 1,
            cloneBaseName: baseIncident.name,
            cloneStartDate: baseIncident.startTime ? moment(baseIncident.startTime).format('YYYY-MM-DD') : new Date().toLocaleDateString('en-CA'),
          }}
          enableReinitialize={true}
          validationSchema={Yup.object({
              cloneAmount: Yup.number()
                .integer('Must be a whole number')
                .min(1, 'Must be at least 1')
                .max(10, 'Maximum is 10')
                .required('Required'),
              cloneBaseName: Yup.string()
                .max(17, 'Must be 17 characters or less')
                .required('Required')
                .test('required-check', 'Name already in use.',
                  function(value) {
                    const newSlug = get_slug(value);
                    const currentSlug = get_slug(baseIncident.name);
                    if (newSlug === currentSlug){
                      return true
                    }
                    return !incidentNames.includes(newSlug);
                  }),
              cloneStartDate: Yup.date().required('Followup date is required'),
          })}
          onSubmit={(values, { setSubmitting }) => {
            axios.put(`/incident/api/incident/${selectedIncident}/clone/`, {
                clone_amount: values.cloneAmount,
                clone_base_name: values.cloneBaseName,
                clone_start_date: values.cloneStartDate
              })
              .then(() => {
                setSelectedIncident(null);
                setShowCloneModal(false);
                window.location.reload();
              })
              .catch(error => {
                console.error("Error cloning incident:", error);
                setShowSystemError(true);
              });
          }}
        >
          {form => (
            <Card border="secondary" className="mt-4 ms-auto me-auto">
              <Card.Body>
                <BootstrapForm>
                  Incident: {baseIncident.name}
                  <Row>
                    <TextInput
                      type="text"
                      label="Clone Base Name"
                      name="cloneBaseName"
                      id="cloneBaseName"
                      xs="12"
                    />
                  </Row>
                  <Row>
                    <DateTimePicker
                      label="Clone(s) Start Date"
                      name={`cloneStartDate`}
                      id={`cloneStartDate`}
                      clearable={false}
                      xs="12"
                      data-enable-time={false}
                      onChange={(date, dateStr) => {
                        form.setFieldValue(`cloneStartDate`, dateStr)
                      }}
                    />
                  </Row>
                  <Row>
                    <TextInput
                      type="text"
                      label="Clone Amount"
                      name="cloneAmount"
                      id="cloneAmount"
                      xs="12"
                    />
                  </Row>
                </BootstrapForm>
              </Card.Body>
              <ButtonGroup size="lg">
                <Button variant="secondary" onClick={handleCloneClose}>
                  Cancel
                </Button>
                <ButtonSpinner isSubmitting={form.isSubmitting} isSubmittingText="Cloning..." className="btn btn-primary border" onClick={() => { form.submitForm() }}>Clone</ButtonSpinner>
              </ButtonGroup>
            </Card>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
    </span> : ""}
    </>
  );
};

export default IncidentManagement;
